import React, { useEffect } from "react";
import { useAppSelector } from "../../../../infra/hooks";
import { documentService } from "../../../../api/services/documentService";
import { commonServices } from "../../../../api/services/commonServices";
interface MyTeamDTOProps {
  setAllCountries: (countries: []) => void;
  setAllEmpDocsType: (empdoctypes: []) => void;
}
function DTOEditDependents({
  setAllCountries,
  setAllEmpDocsType,
}: MyTeamDTOProps) {
  const companyId = useAppSelector((state) => state.authSlice.company_id);

  async function getAllCountries() {
    const response = await commonServices.getCountries();
    if (response) {
      const { data }: any = response;
      setAllCountries(data);
    }
  }
  async function getAllEmpDocsTypes() {
    const response = await documentService.getEmpDocTypes(companyId);
    if (response) {
      const { data }: any = response;
      setAllEmpDocsType(data);
    }
  }
  useEffect(() => {
    getAllEmpDocsTypes();
    getAllCountries();
  }, []);
  return <></>;
}
export default DTOEditDependents;
